import { Box, Typography } from "@mui/material";
import ToleranceGeneralWidget from "../../Widgets/Tolerance/General/General";

const GeneralTolerancePage = () => {
  return (
    <Box>
      <Typography m={3} variant="h3">General tolerance</Typography>

      <ToleranceGeneralWidget />
    </Box>
  );
};

export default GeneralTolerancePage;
